import { Trans } from "@lingui/macro";
import { useEffect, useState } from "react";

import './style.scss'
import crosshair from '@assets/images/crosshair.svg'

const Timeline = ({ markerData, timelineRefs, config, handleMarkerClick, handleRecenterClick, onTimelineOpen }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
        onTimelineOpen(isOpen)
    }

    const recenter = () => {
        handleRecenterClick()
    }

    useEffect(() => {
        if (config) {
            setIsOpen(config?.timeLineOptions?.isOpen)
        }
    }, [config])
    return (
        <div className={`map-timeline-overlay ${isOpen ? 'open' : ''} ${config?.timeLineOptions?.alignment}`}>
            <div style={{ ...config.timeLineOptions?.timelineStyles }} className="map-timeline-content">
                <div>
                    {markerData?.map((marker, i) => (
                        <div key={i} ref={timelineRefs.current[i]} className={`map-timeline-element ${marker?.elementClass}`} onClick={() => handleMarkerClick(i, marker.name)}>
                            <div>
                                {marker?.children?.timelineChildren}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {config?.timeLineOptions?.showToggle &&
                <div onClick={toggle} className={`map-timeline-button toggle ${isOpen ? 'open' : ''}`}>
                    {isOpen ? <h6><Trans>Close</Trans> <i className="icon-x"></i></h6> : <h6><Trans id={config?.timeLineOptions?.buttonLabel} /><i className="icon-chevron-up"></i></h6>}
                </div>
            }

            {config?.timeLineOptions?.showRecenter &&
                <div onClick={recenter} className="map-timeline-button recenter">
                    <h6><Trans>Recentre</Trans> <img alt="" src={crosshair} /></h6>
                </div>
            }
        </div>
    )
}

export default Timeline